/* * 主题活动 * 作者：高苗飞 */
<template>
  <div class="ui-activity" :clstag="'jr|keycount|8530052_contentdetail|activityId_' + activityId + ''">
    <ScrollView ref="scrollView" class="scroll-view-wrapper" :enableAutoRefresh="autoFresh" style="overflow-y:hidden;background:#fff" :probeType="2" :pullup="pullup" @scrollToEnd="scrollToEnd">
      <div class="act">
        <Slider ref="slider" class="act-slide" :autoPlay="isLoop" :loop="true" :data="bannerList">
          <p class="act-htg440" v-for="(item, index) in bannerList" :key="item">
            <a style="height:100%;">
              <img class="act-banner" :src="item" lazy="loaded" />
              <div class="ui-maskDiv"></div>
              <p class="title1" v-bind:style="{ width: winWth + 'px' }">{{ activityDetail.title }}</p>
            </a>
            <span v-if="bannerList && bannerList.length > 1" class="act-text">
              <span>{{ index + 1 }}</span>
              <span class="act-font24">/{{ bannerList.length }}</span>
            </span>
          </p>
        </Slider>
        <!-- 个人头像 -->
        <div class="act-title act-padL36">
          <div class="act-flex act-vcenter act-htg100">
            <img v-lazy="userImg" class="act-logo" />
            <div class="act-padL24">
              <p class="act-username">{{ activityDetail.author }}</p>
            </div>
            <div class="act-padL16">
              <p class="act-date"><span class="ui-line">|</span>{{ activityDetail.releaseTime }}</p>
            </div>
          </div>
        </div>
        <!-- 副标题 -->
        <p class="act-subtitle">
          {{ activityDetail.subTitle }}
        </p>
        <!-- 介绍 -->
        <div v-for="(item, index) in activityContentList" :key="item.id">
          <!-- 尚品位置 -->
          <div class="act-product">
            <div class="act-subProduct act-table">
              <div v-if="item.type == 'imageUrl'" class="act-cell act-pad0 act-wthhtg182">
                <img class="act-wthhtg182 act-bgf" style="width:100%;height: auto;" v-lazy="item.value" />
              </div>
              <div v-if="item.type == 'text'" class="act-cell act-pad0" style="background:#fff;">
                <div class="act-Pinfo">
                  <span v-html="item.value"></span>
                </div>
              </div>
              <div v-if="item.type == 'goodsInfo'" class="act-subProduct act-table" :clstag="'jr|keycount|8530052_contentdetail_sku|' + activityId + '_' + item.value.skuId + '_' + index">
                <KPL class="cls-card" style="height:7rem;" :url="item.value.jumpUrl" :sku="item.value.skuId" :eventId="'MInterestFree_ContentDetailPro'" :eventParam="'activity_' + item.value.skuId">
                  <div class="act-cell act-pad24 act-wthhtg182" style="background:#f7f7f7;">
                    <img class="act-wthhtg182 act-bgf" v-lazy="item.value.imageUrl" />
                  </div>
                  <div class="act-pad10 act-cell" style="background:#f7f7f7;">
                    <div>
                      <div class="product-name">
                        <!-- <span class="ui-hasOver" v-if="!item.value.isValid">无效</span>
                        <span v-bind:class="{ hasActive: !item.value.isValid }">{{item.value.goodsName}}</span> -->
                        <span><span v-if="item.value.isSelfService" class="ui-selfRed">自营</span>{{ item.value.goodsName }}</span>
                      </div>
                      <div class="act-floatL act-left">
                        <div class="act-padT24" v-if="item.value.isValid">
                          <span class="act-month">每月</span>
                          <span class="act-money24cc">¥ </span>
                          <span class="act-money">{{ item.value.installmentPrice }}</span>
                          <!-- <span class="act-money24">×{{item.value.installment}}期免息</span> -->
                        </div>
                        <div class="act-padT24" v-else></div>
                        <div v-if="item.value.isValid" class="act-month-num">
                          <span v-if="false" class="ui-gold">专享</span>
                          <span class="jrm-border-1px jrm-border-homepage-all">{{ item.value.installment }}个月免息</span>
                        </div>

                        <div class="act-subMoney act-pad4 act-padL0" :style="{ 'padding-top': item.value.isValid ? '0.3rem' : '1.4rem' }" v-if="!item.value.isValid">
                          <span class="act-money24">总价</span>
                          <span class="act-money24" style="font-size: 0.75rem;color:#999999;"> ¥</span>
                          <span>{{ item.value.goodsPrice }}</span>
                        </div>
                      </div>
                    </div>
                    <div class="act-padT24">
                      <div class="act-floatR act-buy"><img class="act-go" src="../assets/arr-r.png" /></div>
                    </div>
                  </div>
                </KPL>
              </div>
            </div>
          </div>
        </div>
        <!-- 增加banner资源位 -->
        <div class="active_add_banner_wrap" v-if="isShowBanner">
          <NativeOpenWeb clstag="jr|keycount|jdjr_active_banner|banner" :url="bannerModule.bannerJumpUrl" :eventId="'MInterestFree_ActiveBanner'" :eventParam="'1'">
            <img :src="bannerModule.bannerImageUrl" class="active_add_banner_img" />
          </NativeOpenWeb>
        </div>
        <!-- 查看更多 -->
        <div class="act-more act-padL32 act-marB32" v-if="recommendGoodsList && recommendGoodsList.length > 0">
          <div class="act-moreTitle act-htg100p act-pad32 act-padT48">
            <span class="act-moreTitle1 act-floatL">你可能会喜欢</span>
            <!-- <span class="act-moreTitle2 act-floatR">查看更多 ></span> -->
          </div>
          <Slider :sum="sum" :loop="false" :data="recommendGoodsList" class="act-slide" style="height:15.8rem">
            <p v-for="item in recommendGoodsList" :key="item.id" class="act-htg100" style="height:15.8rem">
              <KPL
                class="cls-card cls-card3"
                style="height:15.8rem;width:97%;"
                :url="item.jumpUrl"
                :sku="item.skuId"
                :eventId="'MInterestFree_ContentDetailRecPro'"
                :eventParam="'activity_' + item.skuId"
              >
                <div style="width:100%;">
                  <img class="act-wthhtg256 act-watch" :src="item.imageUrl" lazy="loaded" />
                </div>

                <p class="act-table  act-wth256 act-marginT20">
                  <span class="act-watchText act-wth256">
                    <p class="act-line2 act-box"><span v-if="item.isSelfService" class="ui-selfRed">自营</span>{{ item.goodsName }}</p>
                  </span>
                  <span class="act-lineHtg8" style="float:left;margin: 0.4rem 0 0;">
                    <span class="act-month act-month-black">每月</span>
                    <span class="act-money24 act-month-red">￥</span>
                    <span class="act-money act-month-red">{{ item.installmentPrice }}</span>
                    <!-- <span class="act-money24c"> ×{{item.installment}}期</span> -->
                  </span>
                </p>

                <div class="act-month-num  act-left-month">
                  <span class="ui-text-gold" style="padding-left:0">
                    <span v-if="false" class="ui-gold">专享</span>
                    <span class="jrm-border-1px jrm-border-homepage-all" style="">{{ item.installment }}个月免息</span>
                  </span>
                </div>
                <!-- <p class="act-mian" style="position:absolute;left0;top:0">{{item.installment}}期免息</p> -->
              </KPL>
            </p>
          </Slider>
        </div>
        <!-- 评论 -->
        <div class="act-htg32 act-wth100 act-padLR32" style="padding-top: 2.5rem;" v-if="isShowComment">
          <span class="act-floatL act-talkTitle">评论</span>
          <span class="act-floatR act-date" @click="goTalk">共{{ (activityDetail.totalCommentCount > 99 ? '99+' : activityDetail.totalCommentCount) || 0 }}条评论 ></span>
        </div>
        <div v-if="isShowComment">
          <div class="act-talk act-padLR0" v-if="commentList.length > 0">
            <DiscussCard class="act-padT0" v-for="(item, index) in commentList" :key="index" :dataSource="item" />
            <div class="act-talk act-padLR0 act-padLR32"></div>
          </div>
          <div v-else class="act-talk act-padLR0 act-padLR32">
            <div class="act-padLR32 act-table act-padT0" @click="toTalk">
              <div class="act-cell act-eyeTitle act-pad0"><img style="height:2rem;" src="../assets/title.png" /></div>
              <div class="act-cell act-eye">说说你的看法吧</div>
            </div>
          </div>
        </div>
        <div class="act-talk act-padLR0 act-padLR32"></div>
      </div>

      <!--遮罩层  -->
      <!-- <div class="ui-maskOn" style="z-index:999999" v-if="isMask">
        <div v-if="isIphonex" class="act-table ui-inputBgx">
          <div class="table-cell" style="padding-left: 1rem;vertical-align: middle;">
            <div style="background: #f7f7f7;height: 2.25rem;padding: 0.5rem 0 0.5rem 0.5rem;"><img class="act-htg36 table-cell" src="../assets/write.png" /></div>
          </div>
          <div class="table-cell" style="line-height: 100%;"><input ref="inputEle"  placeholder="发表评论…" @focus="done" @blur="blur" v-model="share.talk" class="ui-send" maxlength="500"></div>
          <div class="table-cell ui-sendBtn">
            <p style="width: 3rem;text-align:center;" @click="send">发布</p>
          </div>
        </div>
        <div v-else class="act-table ui-inputBg">
          <div class="table-cell" style="vertical-align: middle;">
            <div style="background: #f7f7f7;height: 2.25rem;padding: 0.5rem 0 0.5rem 0.5rem;"><img class="act-htg36 table-cell" src="../assets/write.png" /></div>
          </div>
          <div class="table-cell" style="line-height: 100%;"><input ref="inputEle"  placeholder="发表评论…" @focus="done" @blur="blur" v-model="share.talk" class="ui-send" maxlength="500"></div>
          <div class="table-cell ui-sendBtn">
            <p style="width: 3rem;text-align:center;" @click="send">发布</p>
          </div>
        </div>
        <div class="ui-mask" @click="hideMask"></div>
      </div> -->
    </ScrollView>
    <FavoriteBar
      ref="fa"
      class="jrm-border-1px favorite-border"
      style="position:fixed;bottom:0px;left:0px;width:100%;z-index:999;"
      :icon="icon"
      :favorite="share.favoriteBar"
      :isFavorite="isFavorite"
      :isShowComment="isShowComment"
      :shareData="shareData"
      :isLogin="isLogin"
    ></FavoriteBar>
  </div>
</template>

<style scoped lang="scss">
@import './../scss/mixin.scss';

.ui-activity {
  height: 100%;
  width: 100%;

  .ui-mask {
    opacity: 0.5;
    background: #000000;
    width: 100%;
    height: 100%;
    position: fixed;
    left: 0;
    top: 0;
    z-index: 1;
  }
  .hasActive {
    padding-left: $rem75;
  }
  .ui-line {
    color: rgba(238, 238, 238, 0.8);
    padding-right: $rem16;
  }
  .cls-card {
    box-shadow: none;
  }
  .ui-send {
    font-size: $rem32;
    color: #999999;
    letter-spacing: 0;
    height: $rem72;
    background: #f7f7f7;
    width: 100%;
    padding: $rem2;
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
  }
  .ui-maskOn {
    height: 100%;
    width: 100%;
    position: absolute;
    left: 0;
    top: 0;
  }
  .act-go {
    width: $rem48;
    height: $rem48;
  }
  .act-bable {
    background: #f7f7f7;
    height: $rem72;
    padding: $rem16;
    line-height: $rem40;
  }
  .ui-hasOver {
    background: #999999;
    font-size: $rem20;
    color: #ffffff;
    letter-spacing: 0;
    padding: 0 $rem10;
    position: absolute;
  }
  .ui-sendBtn {
    font-size: $rem32;
    color: #c29451;
    width: $rem96;
    text-align: center;
  }
  .act-box {
    font-size: $rem26;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    white-space: normal;
    text-align: left;
    .ui-selfRed {
      font-family: PingFangSC-Regular;
      font-size: $rem24;
      color: #ffffff;
      background: #f13a4d;
      padding: 0 $rem4;
      line-height: $rem28;
      height: $rem28;
      margin-right: $rem10;
    }
  }
  .ui-inputBg {
    background: #ffffff;
    height: $rem120;
    line-height: $rem120;
    z-index: 999999999;
    width: 100%;
    align-content: center;
    align-items: center;
    justify-content: center;
    padding: 0 $rem24;
    position: fixed;
    bottom: 0;
    left: 0;
  }
  .ui-maskDiv {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    opacity: 0.2;
    background-image: linear-gradient(-180deg, rgba(0, 0, 0, 0.1) 0%, rgba(0, 0, 0, 0.3) 100%);
  }
  .ui-inputBgx {
    background: #ffffff;
    height: $rem86;
    z-index: 999999999;
    width: 100%;
    align-content: center;
    align-items: center;
    justify-content: center;
    padding: $rem24 0 $rem62 0;
    line-height: $rem86;
    position: fixed;
    bottom: 0;
    left: 0;
  }
  input::-webkit-input-placeholder {
    color: #999999;
    font-size: $rem32;
    text-align: left;
  }
  .title1 {
    position: absolute;
    bottom: 0.5rem !important;
    font-size: $rem36;
    color: #ffffff;
    padding: $rem16 $rem32;
    text-align: left;
    z-index: 99999;
    width: $rem600;
    white-space: normal;
    word-break: break-all;
    word-wrap: break-word;
    line-height: $rem48;
  }
  .act-slide {
    height: $rem440;
    overflow-y: hidden;
  }
  .act {
    // background: #ffffff;
    padding-bottom: $rem80;
  }
  .act-eye {
    padding: $rem24 !important;
    background: #f7f7f7;
    height: $rem36;
    font-size: $rem28;
    color: #999999;
    letter-spacing: 0;
  }
  .act-eyeTitle {
    width: $rem80;
  }
  .act-padL32 {
    padding-left: $rem32;
  }
  .act-mian {
    background-image: linear-gradient(89deg, #f8e2a7 0%, #efc287 100%);
    width: $rem107;
    height: $rem40;
    line-height: $rem40;
    font-size: $rem24;
    color: #603b07;
    letter-spacing: 0;
    font-weight: 600;
  }
  .act-line2 {
    line-height: $rem42;
    width: $rem230;
    text-overflow: -o-ellipsis-lastline;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    // padding: 0 $rem8;
  }
  .act-padT24 {
    padding-top: $rem24;
  }
  .act-lineHtg50 {
    line-height: $rem50;
  }

  .act-lineHtg48 {
    line-height: $rem48;
  }
  .act-lineHtg40 {
    line-height: $rem40;
  }
  .act-img {
    width: 100%;
    height: auto;
  }
  .act-htg36 {
    width: $rem36;
    height: $rem36;
  }
  .act-wth100 {
    width: 100%;
  }
  .act-htg32 {
    height: $rem32;
  }
  .act-htg100p {
    height: $rem120 !important;
  }
  .act-htg436p {
    height: $rem436 !important;
  }
  .act-table {
    display: table;
    width: 100%;
    // height: 100%;
  }
  .act-cell {
    display: table-cell;
    vertical-align: middle;
    padding: $rem56;
  }
  .table-cell {
    display: table-cell;
    vertical-align: middle;
    text-align: left;
  }
  .act-flex {
    display: flex;
  }
  .act-flex1 {
    flex: 1;
  }
  .MsoNormal {
    font-size: $rem30 !important;
    color: #333333;
    letter-spacing: 0;
    line-height: $rem56;
  }
  .act-banner-f {
    opacity: 0.5;
    background: #556788;
    color: #ffffff;
    display: inline-block;
    padding: $rem8 $rem16;
  }
  .act-banner {
    width: 100%;
    height: $rem440;
  }
  .act-text {
    font-size: $rem30;
    color: #ffffff;
    letter-spacing: 0;
    line-height: 30px;
    position: relative;
    top: -$rem416;
    float: right;
    padding-right: $rem30;
    z-index: 99999;
  }
  .act-font24 {
    font-size: $rem24;
    color: #ffffff;
  }
  .act-mar05 {
    margin: $rem10;
  }
  .act-padT0 {
    padding-top: 0 !important;
  }
  .act-htg160 {
    background: #ffffff;
    position: relative;
    top: $rem20;
  }
  .product-name {
    font-size: $rem30;
    color: #333333;
    letter-spacing: 0;
    line-height: $rem42;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    text-align: left;
    .ui-selfRed {
      font-family: PingFangSC-Regular;
      font-size: $rem24;
      color: #ffffff;
      background: #f13a4d;
      padding: 0 $rem6;
      line-height: $rem34;
      height: $rem34;
      margin-right: $rem10;
      position: relative;
      top: -$rem4;
    }
  }
  .act-htg440 {
    height: $rem440 !important;
  }

  .act-wthhtg182 {
    width: $rem182;
    height: $rem182;
  }
  .act-wthhtg256 {
    width: 100%;
    height: auto;
  }
  .act-wth256 {
    width: 100%;
  }
  .act-font26 {
    font-size: $rem26;
    color: #666666;
  } // BEST
  .act-font16 {
    font-size: $rem16;
    color: #666666;
  }
  .act-font40 {
    font-size: $rem40;
    color: #333333;
  } // 免息好物推荐
  .act-center {
    text-align: center;
  }
  .act-vcenter {
    align-items: center;
    justify-items: center;
  }
  .act-left {
    text-align: left;
  }
  .act-right {
    text-align: right;
  }
  .act-floatR {
    float: right;
  }
  .act-floatL {
    float: left;
  }
  .act-24bg {
    background-image: url('../assets/act-watch.png');
    background-size: 100% 100%;
  }
  .slider-wrapper {
    width: 100%;
    position: relative;
    overflow: hidden;
  }
  .act-htg100 {
    height: 100%;
  }
  .act-title {
    width: 100%;
    height: $rem124;
    .act-logo {
      width: $rem55;
      height: $rem55;
      border-radius: 50% 50%;
    }
  }
  .act-subtitle {
    width: 100%;
    padding: $rem16 $rem32;
    font-size: $rem30;
    color: #999999;
    letter-spacing: 0;
    line-height: $rem48;
    height: auto;
  }
  .act-subText {
    font-size: $rem30;
    color: #333333;
    letter-spacing: 0;
    line-height: $rem56;
    padding: $rem16 $rem32;
  }
  .act-marginT20 {
    margin-top: $rem20;
    height: $rem119;
  }
  .act-pad0 {
    padding: 0 !important;
  }
  .act-padL0 {
    padding-left: 0 !important;
  }
  .act-pad16 {
    padding: $rem16 0;
  }
  .act-padL36 {
    padding-left: $rem36;
  }
  .act-padL24 {
    padding-left: $rem24;
  }
  .act-pad24 {
    padding: $rem24;
  }
  .act-pad4 {
    padding: $rem4;
  }
  .act-pad32 {
    padding: $rem32 0;
  }
  .act-padT48 {
    padding: $rem48 0 $rem48 0;
  }
  .act-padLR16 {
    padding: $rem16;
  }
  .act-padLR32 {
    padding: $rem32;
  }
  .act-padL68 {
    padding-left: $rem68;
  }
  .act-pad8 {
    padding: $rem8;
  }
  .act-padL16 {
    padding-left: $rem16;
  }
  .act-username {
    font-size: $rem24;
    color: #333333;
    letter-spacing: 0;
    line-height: $rem24;
  }
  .act-date {
    font-size: $rem24;
    color: #999999;
    letter-spacing: 0;
    line-height: $rem24;
  }
  .act-bgf {
    background: #ffffff;
  }
  .act-product {
    padding: $rem16 $rem32;

    .act-subProduct {
      background: #f7f7f7;
      height: 100%;
      width: 100%;
    }
  }
  .act-Pinfo {
    font-size: $rem30;
    color: #333333;
    letter-spacing: 0;
    line-height: $rem56;
  }
  .act-money {
    font-size: $rem28;
    color: #f13a4d;
    letter-spacing: 0;
    line-height: $rem29;
    font-family: Helvetica-Bold;
  }
  .act-money24 {
    font-size: $rem24;
    color: #999999;
    letter-spacing: 0;
  }
  .act-money24c {
    font-size: $rem24;
    color: #999999;
    letter-spacing: 0;
  }
  .act-money24cc {
    font-size: $rem24;
    color: #f13a4d;
    letter-spacing: 0;
    font-family: Helvetica-Bold;
  }
  .act-subMoney {
    font-size: $rem24;
    color: #999999;
    letter-spacing: 0;
    line-height: $rem24;
  }
  .act-buy {
    // background: #c29451;
    border-radius: $rem40;
    color: #ffffff;
    padding: $rem20 $rem5;
    font-size: $rem24;
  }
  .act-pad10 {
    padding: $rem30 $rem24 $rem24 $rem8;
  }
  .act-padLR0 {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }
  .act-more {
    width: 100%;
    // height: $rem595;
    position: relative;
    // top: $rem100;
    background: #f7f7f7;
    .act-moreTitle {
      font-size: $rem30;
      color: #333333;
      letter-spacing: 0;
      .act-moreTitle1 {
        font-size: $rem30;
        color: #333333;
        letter-spacing: 0;
        font-weight: 600;
      }
      .act-moreTitle2 {
        font-size: $rem24;
        color: #999999;
        letter-spacing: 0;
      }
    }
  }
  .act-watch {
    background: #ffffff;
  }
  .act-watchText {
    font-size: $rem28;
    color: #333333;
    letter-spacing: 0;
  }
  .act-talk {
    width: 100%;
    background: #ffffff;
    position: relative;
    // top: $rem100;
    // padding: $rem32;
    // padding-top: $rem60;
  }
  .act-talkTitle {
    font-size: $rem30;
    color: #333333;
    letter-spacing: 0;
    font-weight: 600;
  }
  .act-support {
    width: $rem28;
    height: auto;
    display: inline-block;
  }
  .act-fav {
    position: relative;
    top: $rem80;
    left: 0;
    width: 100%;
  }
  .cls-card3 {
    // box-shadow: 0 0.125rem 0.625rem 0 rgba(187, 187, 187, 0.3);
    // background: #f7f7f7;
    padding-right: $rem16;
  }
  .act-htg5 {
    height: $rem160;
  }
  .act-iphonex {
    height: $rem38;
    width: 100%;
    background: #ffffff;
  }
  .favorite-border {
    box-shadow: 0 -3px 6px 0 rgba(38, 50, 71, 0.03);
    background: #ffffff;
  }
  .slider-item {
    // height: $rem440 !important;
  }
  .active_add_banner_wrap {
    width: 100%;
    min-height: $rem166;
    overflow: hidden;
    padding-top: $rem20;
    padding-bottom: $rem20;
    background-color: #f2f2f2;
  }
  .active_add_banner_img {
    width: 100%;
  }
  .act-month {
    font-family: PingFangSC-Regular;
    font-size: $rem24;
    color: #999;
    margin-right: $rem8;
  }
  .act-month-num {
    font-family: PingFangSC-Regular;
    font-size: $rem24;
    text-align: center;
    color: #c29451;
    margin-top: $rem16;
    white-space: nowrap;
    span {
      font-size: $rem24;
      color: $jrm-color-C29451;
      font-family: PingFangSC-Regular;
      display: inline-block;
      text-align: center;
      padding: $rem4 $rem6;
      line-height: $rem32;
      &.ui-gold {
        font-family: PingFangSC-Regular;
        font-size: $rem24;
        color: #ffffff !important;
        background: #c29451;
        line-height: $rem32;
        padding: $rem4 $rem10;
        // height: $rem28;
      }
    }
  }
  .ui-gold {
    font-family: PingFangSC-Regular;
    font-size: $rem24;
    color: #ffffff !important;
    background: #c29451;
    line-height: $rem32;
    padding: $rem4 $rem10;
  }
  .act-month-black {
    color: #999999;
  }
  .act-month-red {
    color: #f13a4d;
    letter-spacing: 0;
    font-family: PingFangSC-Semibold;
  }
  .act-left-month {
    text-align: left;
    margin-top: $rem17;
  }
}
</style>

<script>
import FavoriteBar from '@/buscomponents/FavoriteBar.vue';
import Slider from '@/components/Slider.vue';
import ScrollView from '@/components/ScrollView.vue';
import DiscussCard from '@/buscomponents/DiscussCard.vue';
import request from '@/util/request';
import KPL from '@/buscomponents/KPL';
import { genLinkBySSR, isIphonex } from '@/util/common';
import { getQueryExt } from '@/util/url';
import { shareInit, HideShare } from '@/util/share';
import { messages } from '@/config';
import NativeOpenWeb from '@/buscomponents/NativeOpenWeb.vue';
export default {
  name: 'active',
  components: {
    FavoriteBar,
    Slider,
    ScrollView,
    DiscussCard,
    KPL,
    NativeOpenWeb
  },
  data() {
    return {
      activityId: '',
      autoFresh: true,
      winWth: document.body.clientWidth,
      list: [],
      isTwoTitle: true,
      isLoop: true,
      data: [],
      pullup: false,
      sum: 2.7,
      isMask: false, // 是否遮罩
      bannerImg: '../assets/act-banner.png',
      icon: '',
      userImg: '',
      share: {
        favoriteBar: { activityId: 1 },
        talk: ''
      },
      isLogin: true,
      focusStatus: false,
      isShowComment: false,
      activityDetail: {},
      activityContentList: [],
      bannerList: [], // 广告位列表
      commentList: [], // 评论列表
      recommendGoodsList: [], // 推荐商品列表
      bannerModule: {}, //banner位
      isShowBanner: false, //bannerImageUrl和bannerJumpUrl有一个没有就不展示
      isFavorite: false,
      shareData: {},
      isIphonex: isIphonex() ? true : false
    };
  },
  created() {
    this.activityId = getQueryExt(this.$route, 'activityId');
    this.share.favoriteBar.activityId = this.activityId;
    this.$loading.show();
    this.getDetails(this.activityId);
  },
  methods: {
    scrollToEnd() {
      console.log(123);
    },
    send() {
      if (this.share.talk.length < 1) {
        this.$toast.show({ text: '评论不能为空' });
        this.hideMask();
        return;
      }
      const activityId = +this.activityId;
      request.addComment({
        data: {
          content: this.share.talk,
          activityId: activityId,
          deviceId: 'test deviceId'
        },
        success: rs => {
          if (rs.issuccess == '1') {
            this.$toast.show({ text: '评论成功' });
            this.share.talk = '';
            this.focusStatus = false;
            this.hideMask();
            this.getDetails(activityId);
          }
        },
        error: msg => {
          clearInterval(this.interval);
          this.$toast.show({ text: msg });
          this.focusStatus = false;
          this.hideMask();
        }
      });
    },
    hideMask() {
      this.isMask = false;
      this.focusStatus = false;
    },
    toShare() {
      console.log('share');
      this.$refs.FavoriteBar.toShare();
    },
    goTalk() {
      const activityId = +this.activityId;
      this.$router.push({ path: '/discusslist', query: { activityId: activityId } });
    },
    toTalk() {
      this.$refs.fa.toTalk();
    },
    // done() {
    //   this.bfscrolltop = document.body.scrollTop; //获取软键盘唤起前浏览器滚动部分的高度
    //   this.interval = setTimeout(function() {
    //     //设置一个计时器，时间设置与软键盘弹出所需时间相近
    //     document.body.scrollTop = document.body.scrollHeight; //获取焦点后将浏览器内所有内容高度赋给浏览器滚动部分高度
    //     $('input.ui-send').focus();
    //   }, 900);
    // },
    // blur() {
    //   clearTimeout(this.interval); //清除计时器
    // },
    edit() {
      $(this.$refs.inputEle).focus();
    },
    getDetails(activityId) {
      request.getActivityDetail({
        // 参数
        data: {
          activityId: +activityId
        },
        success: rs => {
          this.$loading.hide();
          this.activityDetail = rs.activityDetail;
          this.activityContentList = rs.activityDetail.activityContentList;
          this.bannerList = rs.activityDetail.bannerList;
          this.commentList = rs.activityDetail.commentList;
          this.isLogin = rs.activityDetail.isLogin;
          this.recommendGoodsList = rs.activityDetail.recommendGoodsList;
          this.userImg = rs.activityDetail.avatar;
          this.isFavorite = rs.activityDetail.isFavorite;
          this.icon = rs.activityDetail.bannerList[0];
          this.isShowComment = rs.activityDetail.isShowComment;
          this.shareData = {
            shareTitle: rs.activityDetail.shareInfo.shareTitle,
            shareSubTitle: rs.activityDetail.shareInfo.shareSubTitle,
            shareImageUrl: rs.activityDetail.shareInfo.shareImageUrl
          };
          //增加banner位 bannerImageUrl和bannerJumpUrl有一个没有就不展示
          const { bannerModule } = rs.activityDetail || {};
          if (bannerModule && bannerModule.bannerImageUrl && bannerModule.bannerJumpUrl) {
            this.isShowBanner = true;
          } else {
            this.isShowBanner = false;
          }
          this.bannerModule = bannerModule || {};
          this.$nextTick(() => {
            setTimeout(() => {
              // console.log(this.$refs.scrollView.scroll);
              // console.log('maxScrollY', this.$refs.scrollView.scroll.maxScrollY);
              // alert(this.$refs.scrollView.scroll.maxScrollY);
              if (this.$refs && this.$refs.scrollView) {
                this.$refs.scrollView.refresh();
              }
            }, 300);
          });

          this.initShare();
        },
        // 接口错误，在error方法后调用
        afterError: () => {
          this.$loading.hide();
        }
      });
    },
    initShare() {
      const _shareData = this.shareData || {};
      const _href = genLinkBySSR('activity');
      console.log(_shareData);
      const defaultOption = {
        shareURL: _href,
        shareImgSrc: _shareData.shareImageUrl || 'https://img12.360buyimg.com/jrpmobile/jfs/t28069/118/1531685442/19730/8e0317ae/5ce36be5Nf2ce9f2c.png',
        shareTitle: _shareData.shareTitle || messages.shareTitle,
        shareDesc: _shareData.shareSubTitle || messages.shareDesc,
        shareChannels: ['0', '1', '3']
      };
      shareInit(defaultOption);
    }
  },
  watch: {
    activityDetail: {
      handler(curVal, oldVal) {
        oldVal = curVal;
        console.log(oldVal);
      },
      deep: true
    }
  },
  mounted() {
    this.initShare();
    HideShare({ title: '活动详情', moreItem: true, hideTools: false, backColor: '#ffffff', textColor: 2 });
  },
  destroyed() {
    this.$refs = null;
    this._self = null;
  }
};
</script>
